import React, { createContext, useContext } from 'react';
import CRYRTheme from './theme';
import './theme.css';

// Create Theme Context
const ThemeContext = createContext();

// Theme Provider Component
export const ThemeProvider = ({ children }) => {
  const theme = CRYRTheme;

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to use theme
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

// Higher-order component for themed components
export const withTheme = (Component) => {
  return function ThemedComponent(props) {
    const theme = useTheme();
    return <Component {...props} theme={theme} />;
  };
};

// Theme utilities
export const getThemeColor = (path) => {
  const keys = path.split('.');
  let value = CRYRTheme.colors;
  
  for (const key of keys) {
    value = value[key];
    if (value === undefined) return null;
  }
  
  return value;
};

export const getThemeSpacing = (size) => CRYRTheme.spacing[size] || size;
export const getThemeFontSize = (size) => CRYRTheme.typography.fontSize[size] || size;
export const getThemeBorderRadius = (size) => CRYRTheme.borderRadius[size] || size;

export default ThemeProvider;
